const GREEN_ATTRIBUTE = 'greenattribute';
const ECOWISE = 'ecowise';

const isEcowise = items => {
    if (!items || !Array.isArray(items) || !items.length) {
        return false;
    }

    const greenAttrItem = items.find(item => item.code.toLowerCase().includes(GREEN_ATTRIBUTE));

    if (!greenAttrItem || !greenAttrItem.values || !greenAttrItem.values.length) {
        return false;
    }

    const stringOfValues = greenAttrItem.values.join(',').toLowerCase();

    return stringOfValues.includes(ECOWISE);
};

export default isEcowise;
